export default {
  // Hero
  'hero.badge': '투명한 프로세스',
  'hero.title': '이용 방법',
  'hero.subtitle': '제품 선택부터 최종 배송까지',
  'hero.imageAlt': '화장품 포장 공장 생산 라인',

  // Step labels
  'step.label': '단계',
  'step.titleSuffix': '화장품 포장 프로세스',
  'hero.desc':
    '고객님의 아이디어를 처음 공유하는 순간부터 완제품이 안전하게 배송되기까지, 제조 프로젝트의 모든 단계가 어떻게 투명하고 전문적으로 관리되는지 확인해 보세요.',

  // Process overview
  'overview.label': '전체 프로세스',
  'overview.title': '한눈에 보는 전체 여정',
  'overview.subtitle':
    '신중하게 관리되는 13개의 단계가 고객님의 아이디어를 단순한 문의에서 완성된 제품으로 이끕니다. 각 단계는 서로 연결되어 품질이 관리되므로 어떤 것도 우연에 맡기지 않습니다.',
  'overview.track1.title': '상담 및 기획',
  'overview.track1.desc': '첫 문의부터 사양, 견적, 샘플, 승인까지 — 1~7단계.',
  'overview.track2.title': '생산 및 배송',
  'overview.track2.desc': '대량생산부터 검사, 포장, 배송, 사후관리까지 — 8~13단계.',

  // Step 1
  'steps.1.title': '제품 검색 및 문의',
  'steps.1.desc':
    '제품 목록, 카테고리 검색, 이미지 기반 유사 검색을 통해 적합한 용기를 찾고, 요구사항과 함께 문의해 주세요.',
  'steps.1.note':
    '제품 이미지와 목표 수량을 함께 전달해 주시면 더 빠르고 정확하게 검토할 수 있습니다.',
  'steps.1.item1': '제품 검색 및 비교',
  'steps.1.item2': '이미지로 유사 제품 찾기',
  'steps.1.item3': 'MOQ, 재질, 용량 및 재고 상태 확인',
  'steps.1.item4': '원하는 제품이 없을 경우 맞춤 제품 문의',
  'steps.1.item5': '제품, 수량, 국가 및 예상 일정 전달',

  // Step 2
  'steps.2.title': '요구사항 및 사양 검토',
  'steps.2.desc':
    '견적 전에 고객님의 요구사항과 제품 사양을 구체적으로 확인하여 모든 세부사항이 정확히 이해되도록 합니다.',
  'steps.2.note':
    '정확한 사양 검토가 견적과 샘플의 품질을 결정합니다.',
  'steps.2.item1': '용기 종류와 용량',
  'steps.2.item2': '재질과 색상',
  'steps.2.item3': '펌프, 캡 및 기타 부자재 구성',
  'steps.2.item4': '내용물과 용기의 호환성 검토',
  'steps.2.item5': '인쇄, 코팅, 라벨 및 후가공 선택',
  'steps.2.item6': '목표 수량과 납기',
  'steps.2.item7': '배송 국가 및 거래조건',
  'steps.2.item8': '고객 디자인 파일 확인',

  // Step 3
  'steps.3.title': '견적 및 프로젝트 확정',
  'steps.3.desc':
    '확정된 사양을 기준으로 견적과 생산조건을 고객님과 함께 검토합니다.',
  'steps.3.note':
    '견적은 최종 사양, 수량, 후가공, 환율 및 배송조건에 따라 달라질 수 있습니다.',
  'steps.3.item1': '제품 단가',
  'steps.3.item2': 'MOQ',
  'steps.3.item3': '샘플 및 금형 비용',
  'steps.3.item4': '인쇄와 후가공 비용',
  'steps.3.item5': '포장 및 예상 운송비',
  'steps.3.item6': '예상 생산기간',
  'steps.3.item7': '결제조건과 견적 유효기간',
  'steps.3.item8': '국제 거래조건 확인',

  // Step 4
  'steps.4.title': '샘플 제작 및 승인',
  'steps.4.desc':
    '대량생산 전에 실제 샘플과 프로토타입을 통해 제품과 디자인을 확인합니다.',
  'steps.4.note':
    '샘플 승인 없이 중요한 맞춤 생산은 진행하지 않습니다. 이것이 저희의 핵심 품질 원칙입니다.',
  'steps.4.item1': '기존 제품 샘플 발송',
  'steps.4.item2': '맞춤 색상 및 후가공 샘플 제작',
  'steps.4.item3': '디자인 시안 확인',
  'steps.4.item4': '금형 또는 프로토타입 제작',
  'steps.4.item5': '고객의 샘플 평가',
  'steps.4.item6': '수정사항 반영',
  'steps.4.item7': '최종 샘플 승인',

  // Step 5
  'steps.5.title': '주문 및 결제 확정',
  'steps.5.desc':
    '최종 사양과 샘플이 승인된 후 정식 주문을 확정합니다.',
  'steps.5.note':
    'Proforma Invoice와 계약조건이 확인된 후에 생산이 시작됩니다.',
  'steps.5.item1': '최종 견적서 또는 Proforma Invoice 확인',
  'steps.5.item2': '제품 사양서 확정',
  'steps.5.item3': '주문수량 확정',
  'steps.5.item4': '납품일정 확인',
  'steps.5.item5': '배송정보 확인',
  'steps.5.item6': '계약 및 결제조건 확인',
  'steps.5.item7': '생산 주문번호 생성',

  // Step 6
  'steps.6.title': '생산 전 준비',
  'steps.6.desc':
    '대량생산을 시작하기 전에 모든 생산조건을 한 번 더 점검합니다.',
  'steps.6.note':
    '생산 전 모든 조건을 재확인하여 대량생산 리스크를 최소화합니다.',
  'steps.6.item1': '최종 승인 샘플과 생산 사양 비교',
  'steps.6.item2': '원재료와 부자재 준비',
  'steps.6.item3': '금형 및 생산설비 점검',
  'steps.6.item4': '색상과 인쇄 데이터 확인',
  'steps.6.item5': '생산계획과 품질검사 기준 수립',
  'steps.6.item6': '생산 전 내부 승인',

  // Step 7
  'steps.7.title': '원자재 및 수입 검사',
  'steps.7.desc':
    '생산에 투입되는 원재료와 부자재를 사용 전에 검사합니다.',
  'steps.7.note':
    '기준에 미달하는 자재는 절대 생산에 투입되지 않습니다.',
  'steps.7.item1': '원재료 확인',
  'steps.7.item2': '펌프, 캡 및 부속품 검사',
  'steps.7.item3': '색상과 재질 확인',
  'steps.7.item4': '공급 부자재의 규격 확인',
  'steps.7.item5': '불량 또는 기준 미달 자재 분리',
  'steps.7.item6': '검사 결과 기록',

  // Step 8
  'steps.8.title': '대량생산',
  'steps.8.desc':
    '자동화된 대규모 생산시설에서 제품을 생산합니다.',
  'steps.8.note':
    '배치 단위 추적관리로 모든 주문의 생산 이력을 관리할 수 있습니다.',
  'steps.8.item1': '자동화 생산라인',
  'steps.8.item2': '사출, 블로우, 튜브 및 유리용기 생산',
  'steps.8.item3': '공정별 생산관리',
  'steps.8.item4': '작업조건과 생산수량 관리',
  'steps.8.item5': '생산 배치 및 추적관리',
  'steps.8.item6': '전문 작업자와 품질관리자의 공정 감독',

  // Step 9
  'steps.9.title': '공정 중 품질관리',
  'steps.9.desc':
    '생산 중 발생할 수 있는 문제를 조기에 발견하기 위해 공정 검사를 수행합니다.',
  'steps.9.note':
    '문제를 조기에 발견하면 전체 배치의 불량률을 낮출 수 있습니다.',
  'steps.9.item1': '외관과 색상 확인',
  'steps.9.item2': '크기와 중량 확인',
  'steps.9.item3': '조립상태 검사',
  'steps.9.item4': '펌프 작동상태 검사',
  'steps.9.item5': '누액과 밀폐상태 확인',
  'steps.9.item6': '인쇄 위치와 인쇄 품질 확인',
  'steps.9.item7': '공정 중 불량품 분리',
  'steps.9.item8': '필요 시 생산조건 조정',

  // Step 10
  'steps.10.title': '최종 품질검사',
  'steps.10.desc':
    '생산이 완료된 제품을 출하하기 전에 최종 검사를 수행합니다.',
  'steps.10.note':
    '인증, 검사기준, 합격률 등은 실제 적용이 확인된 경우에만 적용하며, 구체적인 수치는 확정 전까지 placeholder로 표시됩니다.',
  'steps.10.item1': '최종 외관검사',
  'steps.10.item2': '수량검사',
  'steps.10.item3': '치수와 규격검사',
  'steps.10.item4': '기능과 조립검사',
  'steps.10.item5': '누액 및 밀폐 테스트',
  'steps.10.item6': '인쇄와 후가공 상태 확인',
  'steps.10.item7': '포장상태 검사',
  'steps.10.item8': '승인 샘플과 완제품 비교',
  'steps.10.item9': '고객이 요구한 검사기준 적용',
  'steps.10.item10': '필요 시 검사보고서 제공',

  // Step 11
  'steps.11.title': '포장 및 출하 준비',
  'steps.11.desc':
    '검사가 완료된 제품을 안전하게 포장하고 출하를 준비합니다.',
  'steps.11.note':
    '수출용 포장과 선적서류를 사전에 준비하여 지연을 방지합니다.',
  'steps.11.item1': '제품별 보호포장',
  'steps.11.item2': '내부 포장과 수출용 Carton 포장',
  'steps.11.item3': '수량 및 라벨 확인',
  'steps.11.item4': '파손과 오염 방지',
  'steps.11.item5': 'Pallet 작업 여부 확인',
  'steps.11.item6': 'Packing List 작성',
  'steps.11.item7': '선적서류 준비',
  'steps.11.item8': '출하 전 최종 확인',

  // Step 12
  'steps.12.title': '국제배송 및 추적',
  'steps.12.desc':
    '고객님이 지정한 국가와 배송조건에 따라 제품을 운송합니다.',
  'steps.12.note':
    '운송기간과 비용은 국가, 운송방식, 통관 및 현지 상황에 따라 달라질 수 있습니다.',
  'steps.12.item1': '특송, 항공 및 해상운송',
  'steps.12.item2': '운송방식과 예상 일정 확인',
  'steps.12.item3': '운송업체 또는 Forwarder 연결',
  'steps.12.item4': '수출통관 서류 준비',
  'steps.12.item5': '선적 진행상태 안내',
  'steps.12.item6': 'Tracking 정보 제공',
  'steps.12.item7': '배송지 도착 확인',

  // Step 13
  'steps.13.title': '배송 완료 및 사후관리',
  'steps.13.desc':
    '제품이 전달된 후 주문을 마무리하고 지속적인 사후 지원을 제공합니다.',
  'steps.13.note':
    '문제 발생 시 사진과 기록을 바탕으로 원인을 분석하고, 합의된 정책에 따라 대응합니다.',
  'steps.13.item1': '배송완료 확인',
  'steps.13.item2': '수령 제품과 수량 확인',
  'steps.13.item3': '파손 또는 품질문제 접수',
  'steps.13.item4': '관련 사진과 자료 확인',
  'steps.13.item5': '문제 원인 분석',
  'steps.13.item6': '합의된 정책에 따른 대응',
  'steps.13.item7': '재주문 및 후속 프로젝트 지원',

  'steps.1.short': '검색 및 문의',
  'steps.2.short': '사양 검토',
  'steps.3.short': '견적',
  'steps.4.short': '샘플 및 승인',
  'steps.5.short': '주문 및 결제',
  'steps.6.short': '생산 전 준비',
  'steps.7.short': '자재 검사',
  'steps.8.short': '대량생산',
  'steps.9.short': '공정 중 검사',
  'steps.10.short': '최종 검사',
  'steps.11.short': '포장',
  'steps.12.short': '배송 및 추적',
  'steps.13.short': '배송 완료 및 사후관리',

  // Stock vs Custom
  'compare.label': '두 가지 경로',
  'compare.title': '재고상품 vs 맞춤 생산',
  'compare.subtitle':
    '일반 재고상품과 맞춤 생산상품은 진행 과정과 소요시간이 다릅니다. 필요에 맞는 경로를 선택하세요.',
  'compare.stock.title': '재고상품',
  'compare.stock.desc': '간단한 확인 후 빠르게 출고할 수 있는 기성품입니다.',
  'compare.stock.step1': '재고확인',
  'compare.stock.step2': '견적',
  'compare.stock.step3': '결제',
  'compare.stock.step4': '출고',
  'compare.stock.step5': '배송',
  'compare.custom.title': '맞춤 생산',
  'compare.custom.desc': '고객님의 정확한 사양에 맞춰 제작되는 주문형 제품입니다.',
  'compare.custom.step1': '사양협의',
  'compare.custom.step2': '견적',
  'compare.custom.step3': '샘플',
  'compare.custom.step4': '승인',
  'compare.custom.step5': '대량생산',
  'compare.custom.step6': '검사',
  'compare.custom.step7': '배송',

  // Order progress
  'progress.label': '주문 진행 확인',
  'progress.title': 'My Page에서 주문 상태를 추적하세요',
  'progress.subtitle':
    '문의부터 배송까지 주문이 진행되는 모든 단계를 개인 대시보드에서 확인할 수 있습니다.',
  'progress.status1': '문의 접수',
  'progress.status2': '사양 검토',
  'progress.status3': '견적 발송',
  'progress.status4': '샘플 진행 중',
  'progress.status5': '샘플 승인',
  'progress.status6': '주문 확정',
  'progress.status7': '생산 중',
  'progress.status8': '품질검사',
  'progress.status9': '출하 준비 완료',
  'progress.status10': '배송 중',
  'progress.status11': '배송 완료',
  'progress.note':
    '이는 My Page에서 주문 상태가 표시되는 방식을 보여주는 UI 예시입니다. 실제 상태 업데이트는 주문 데이터가 연결되면 반영됩니다.',

  // Quality assurance
  'qa.label': '지속적인 품질',
  'qa.title': '모든 단계에서의 품질 보증',
  'qa.subtitle':
    '품질은 한 번만 검사되지 않습니다. 생산의 모든 다음 단계에서 지속적으로 관리됩니다.',
  'qa.stage1.title': '수입 자재 검사',
  'qa.stage1.desc': '원재료와 부자재는 생산 투입 전에 검사됩니다.',
  'qa.stage2.title': '생산 전 검증',
  'qa.stage2.desc': '생산 시작 전에 승인 샘플과 생산조건을 대조합니다.',
  'qa.stage3.title': '공정 중 검사',
  'qa.stage3.desc': '라인에서 제품을 검사하여 문제를 조기에 발견합니다.',
  'qa.stage4.title': '최종 검사',
  'qa.stage4.desc': '출하 전 완제품에 대한 최종 검사를 수행합니다.',
  'qa.stage5.title': '포장 검사',
  'qa.stage5.desc': '보호와 라벨 표기가 올바른지 포장을 검증합니다.',
  'qa.stage6.title': '출하 검증',
  'qa.stage6.desc': '선적 전에 서류와 적재 상태를 확인합니다.',

  // Final CTA
  'cta.label': '시작할 준비가 되셨나요',
  'cta.title': '포장 프로젝트를 시작하세요',
  'cta.subtitle':
    '재고 용기가 필요하든 완전한 맞춤 제품이 필요하든, 저희 팀이 모든 단계를 안내해 드립니다.',
  'cta.browse': '제품 둘러보기',
  'cta.quote': '견적 요청',
  'cta.custom': '맞춤 프로젝트 시작',
  'cta.contact': '상담 문의',
};